import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2 flex-col" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import SelectList from "shared/components/other/OaiListbox.vue";
import { HierarchyTagStore } from "shared/types/HierarchyTag";
import { Report } from "@/types/Report";
import {
  UnitValuesAggregation,
  UnitValuesReportConfig,
  UnitValuesReportFilters,
} from "@/types/reports/PlotUnitValues";
import ReportFormSection from "@/views/reports/components/ReportFormSection.vue";
import ReportLocationFilterField from "@/views/reports/filters/ReportLocationFilterField.vue";
import ReportUnitValueTypeFilterField from "@/views/reports/filters/ReportUnitValueTypeFilterField.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitValuesForm',
  props: {
    filters: {},
    config: {},
    aggregation: {},
    hierarchyTags: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();

const aggregationOptions = computed(() => {
  const availableHierarchyTags = Array.from(
    new Set(props.hierarchyTags.map((tag) => tag.type).filter((tag) => tag !== "component")),
  ).sort((a, b) =>
    a === "building" ? -1 : b === "building" ? 1 : a === "level" ? -1 : b === "level" ? 1 : 0,
  );
  return availableHierarchyTags.map((tag) => ({
    name: t(`analytics.reports.by_${tag}`),
    value: tag,
  }));
});

const handleAggregationChange = (aggregation: UnitValuesAggregation) => {
  emit("change", { aggregation });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ReportFormSection, {
      number: "2",
      label: _unref(t)('analytics.reports.filters')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ReportUnitValueTypeFilterField, {
            filter: _ctx.filters.unit_value_type,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('change', { filters: { ..._ctx.filters, unit_value_type: $event } })))
          }, null, 8, ["filter"]),
          _createVNode(ReportLocationFilterField, {
            filter: _ctx.filters.location,
            hierarchyTags: _ctx.hierarchyTags,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('change', { filters: { ..._ctx.filters, location: $event } })))
          }, null, 8, ["filter", "hierarchyTags"])
        ])
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(ReportFormSection, {
      number: "3",
      label: _unref(t)('analytics.reports.aggregation'),
      defaultOpen: false
    }, {
      default: _withCtx(() => [
        _createVNode(SelectList, {
          options: aggregationOptions.value,
          defaultSelected: _ctx.aggregation,
          "onUpdate:selected": handleAggregationChange
        }, null, 8, ["options", "defaultSelected"])
      ]),
      _: 1
    }, 8, ["label"])
  ], 64))
}
}

})